import { Button } from "primereact/button";
import PlusIcon from "@/assets/icons/tipo-plus.svg?react";
import { ESCOPO_MACRO } from "../../../nova-obra.constants";
import { EscopoMacroLinha } from "./components/escopo-macro-linha";
import { EscopoMacroNovo } from "./components/escopo-macro-novo";
import styles from "./escopo-macro-secao.module.scss";
import type { EscopoMacroCasca, EscopoMacroSecaoViewModel } from "./types-escopo-macro-secao";

/**
 * Seção "Escopos Macro" do corpo do `tipo-obra/card` (Figma 10691:1406): título com contador, linhas recolhidas, escopo novo
 * aberto e "Adicionar escopo macro". Só a casca visual: o estado vem por prop e todos os controles ficam desabilitados.
 */
export function EscopoMacroSecaoView(props: EscopoMacroCasca & EscopoMacroSecaoViewModel) {
  const { estado, total, linhas, comNovo } = props;

  return (
    <section className={styles.secao} data-testid="escopo-macro-secao" data-estado={estado}>
      <div className={styles.titulo}>
        <h4 className={styles.tituloTexto}>{ESCOPO_MACRO.titulo}</h4>
        <span className={styles.tituloQuantidade}>{ESCOPO_MACRO.quantidade(total)}</span>
      </div>
      {linhas.map((linha) => (
        <EscopoMacroLinha key={linha.id} {...linha} />
      ))}
      {comNovo ? <EscopoMacroNovo /> : null}
      <Button
        type="button"
        className={styles.adicionar}
        text
        size="small"
        severity="secondary"
        icon={<PlusIcon aria-hidden />}
        label={ESCOPO_MACRO.adicionar}
        disabled
      />
    </section>
  );
}
